import Vue from 'vue'
import App from './App'
import router from './router'
import store from './assets/store/store'
//import "@lottiefiles/lottie-player";



global.WEBROOT = 'https://challenge-admin.eu-1.pixcham.com';

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)

import WOW from 'wow.js'
new WOW().init();

import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput);

import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll);

import { FormDatepickerPlugin } from 'bootstrap-vue'
Vue.use(FormDatepickerPlugin)

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

Vue.use(DatePicker)

import VCalendar from 'v-calendar';
//import { VCalendar } from 'v-calendar/src/components/index.js';
//Vue.use(VCalendar)
Vue.use(VCalendar);

let referer = document.referrer;
console.log('MAIN locale', referer, store.state.activeLang );

if( referer )
{
  let locale = referer.match( /https:\/\/([a-z]{2})\.pixcham\.com/ );
  
  console.log('locale main', locale);
  if( locale && locale[1] && typeof locale[1] === 'string' && locale[1].length === 2 )
  {
    console.log('REFERRER', locale[1]);
    
    store.commit("updateActiveLang", locale[1]);
  }
  else if( referer.includes( 'https://www.pixcham.com' ) )
  {
    store.commit("updateActiveLang", 'en' );
  }
}

import VueI18n from 'vue-i18n';
import { defaultLocale, langTexts } from './assets/locale/index.js'
Vue.use(VueI18n);

let superDefaultLanguage = defaultLocale;
if( store.state.activeLang )
{
  superDefaultLanguage = store.state.activeLang;
}
else if(navigator.language.split('-')[0])
{
  superDefaultLanguage = navigator.language.split('-')[0];
}

console.log( 'superDefaultLanguage', superDefaultLanguage );

export const messages = Object.assign(langTexts)
export const i18n = new VueI18n({
  locale: superDefaultLanguage,
  fallbackLocale: superDefaultLanguage,
  messages
})

const i18nn = i18n;

export { i18nn };


import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import DialogPlugin from './plugins/dialog'

Vue.use(DialogPlugin) // 💥 hotovo

import vueFilePond, { setOptions } from 'vue-filepond';

/*
setOptions({
      server: {
          process: {
              url: 'https://cdn.pixcham.com/upload',
              method: 'POST',
              withCredentials: false,
              headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('access_token')
              },
              onload: null,
              onerror: null
          }
      }
  });
  */

  /*
setOptions({
  server: {
    process: async (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
      // fieldName is the name of the input field
      // file is the actual file object to send
      console.log('PROCESS FILE', { file, fieldName, options } );

      let extension = ( file && file.type ? file.type.split('/')[1] : '' );

      const { getURL, putURL, path } = await fetch( 'https://challenge-admin.eu-1.pixcham.com/tmpURL?extension='+extension, 
      {
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin'
      }).then( r => r.json() );
      
      console.log( 'RESPONSE', getURL );
      console.log('URL LINK', putURL );
      console.log('PATH', path );

      file.get_path = getURL;
      file.tmp_path = path;
      
      const request = new XMLHttpRequest();
      request.open('PUT', putURL);

      // Should call the progress method to update the progress to 100% before calling load
      // Setting computable to false switches the loading indicator to infinite mode
      request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, e.total);
      };

      // Should call the load method when done and pass the returned server file id
      // this server file id is then used later on when reverting or restoring a file
      // so your server knows which file to return without exposing that info to the client
      request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
              // the load method accepts either a string (id) or an object
              load(request.responseText);
          } else {
              // Can call the error method if something is wrong, should exit after
              error('oh no');
          }
      };

      //request.send(formData);
      //console.log('file 2 ', file );
      request.overrideMimeType(file.type);

      request.send(file);
      
      // Should expose an abort method so the request can be cancelled
      
      console.log('response 2 text = ', request );
      return { abort: () => {
          // This function is entered if the user has tapped the cancel button
          request.abort();

          // Let FilePond know the request has been cancelled
          abort();
      }};
      
      //return getURL;

      
    }
  }
});
*/

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import {langs} from "@/assets/locale";
import SendPromoCode from "@/components/SendPromoCode";
//import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType);


Vue.mixin({
  methods: {
    capitalizeFirstLetterCustom: str => { return str.charAt(0).toUpperCase() + str.slice(1); },
    formatPrice: value => {
      var amount = Number(value);
      if (!isFinite(amount)) { amount = 0; }
      var formatter = new Intl.NumberFormat('sk-SK', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0
      });
      return formatter.format(amount); /* $2,500.00 */
    },
    formatTime: ( time ) => {

      var date = new Date( ( !isNaN(time) ? time * 1000 : time ) );

      let lang = store.getters.activeLang;

      let defaulLang = 'en-US';
      if( lang === 'sk' ){ defaulLang = 'sk-SK'; }

      let day = date.getDate();
      let month = date.toLocaleString(defaulLang, { month: 'short' });
      month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
      let year = date.getFullYear();
      
      if( lang === 'en' )
      {
        return month + ' ' + day + ', ' + year + ' ' + date.toLocaleString(defaulLang, { hour: 'numeric', minute: 'numeric', hour12: false });
      }
      else
      {
        return day + '. ' + month + ' ' + year + ' ' + date.toLocaleString(defaulLang, { hour: 'numeric', minute: 'numeric', hour12: false });
      }
    },
    formatDate: ( time ) => {

      var date = new Date( ( !isNaN(time) ? time * 1000 : time ) );

      let lang = store.getters.activeLang;

      let defaulLang = 'en-US';
      if( lang === 'sk' ){ defaulLang = 'sk-SK'; }

      let day = date.getDate();
      let month = date.toLocaleString(defaulLang, { month: 'short' });
      month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
      let year = date.getFullYear();
      
      if( lang === 'en' )
      {
        return month + ' ' + day + ', ' + year;
      }
      else
      {
        return day + '. ' + month + ' ' + year;
      }
    },
    formatDates: ( time, time2 ) => {

      var date_one = new Date(( !isNaN(time) ? time * 1000 : time ));
      var date_two = new Date(( !isNaN(time2) ? time2 * 1000 : time2 ));

      
      let lang = store.getters.activeLang;

      let defaulLang = 'en-US';
      if( lang === 'sk' ){ defaulLang = 'sk-SK'; }

      let day_one = date_one.getDate();
      let month_one = date_one.toLocaleString(defaulLang, { month: 'short' });
      month_one = month_one.charAt(0).toUpperCase() + month_one.slice(1).toLowerCase();
      let year_one = date_one.getFullYear();

      let day_two = date_two.getDate();
      let month_two = date_two.toLocaleString(defaulLang, { month: 'short' });
      month_two = month_two.charAt(0).toUpperCase() + month_two.slice(1).toLowerCase();
      let year_two = date_two.getFullYear();

      if( store.getters.activeLang === 'en' )
      {
        if( month_one === month_two && year_one === year_two )
        {
          return month_one + ' ' + day_one + ' - ' + day_two + ', ' + year_one;
        }
        else
        {
          return month_one + ' ' + day_one + ', ' + year_one + ' - ' + month_two + ' ' + day_two + ', ' + year_two;
        }
        
      }
      else
      {
        if( month_one === month_two && year_one === year_two )
        {
          return  day_one + ' - ' + day_two + ', ' + month_one + ' ' + year_one;
        }
        else
        {
          return day_one + ', ' + month_one + ' ' + year_one + ' - ' + day_two + ', ' + month_two + ' ' + year_two;
        }
      }
    },
    isMobile: () => {
      if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
          )
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
})


Vue.config.devtools = true
Vue.config.productionTip = false
//Vue.use(require('vue-moment'));

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  i18n,
  render: h => h(App),
}).$mount('#app');